/**
 * Tiles of the container and utility blocks (game/utility/defs.ts): the
 * vanilla texture each one is loaded from (public/mc/<name>.png, extracted by
 * scripts/extract-minecraft-textures.mjs) and the plain placeholder drawn
 * while a file has not been extracted.
 */
import { T } from '../blocks';

type Painter = (ctx: CanvasRenderingContext2D, rnd: () => number) => void;

/** Vanilla texture file per tile. */
export function utilityTileFiles(): Record<number, string> {
  return {
    [T.HOPPER_OUTSIDE]: 'hopper_outside', [T.HOPPER_TOP]: 'hopper_top', [T.HOPPER_INSIDE]: 'hopper_inside',
    [T.DISPENSER_FRONT]: 'dispenser_front', [T.DISPENSER_FRONT_V]: 'dispenser_front_vertical',
    [T.DROPPER_FRONT]: 'dropper_front', [T.DROPPER_FRONT_V]: 'dropper_front_vertical',
    [T.SHULKER_TOP]: 'shulker_box', [T.SHULKER_SIDE]: 'shulker_box', [T.SHULKER_BOTTOM]: 'shulker_box',
    [T.CAULDRON_SIDE]: 'cauldron_side', [T.CAULDRON_TOP]: 'cauldron_top', [T.CAULDRON_INNER]: 'cauldron_inner', [T.CAULDRON_BOTTOM]: 'cauldron_bottom',
    [T.CAKE_TOP]: 'cake_top', [T.CAKE_SIDE]: 'cake_side', [T.CAKE_INNER]: 'cake_inner', [T.CAKE_BOTTOM]: 'cake_bottom',
    [T.LADDER]: 'ladder', [T.VINE]: 'vine', [T.CHAIN]: 'chain',
    [T.LANTERN]: 'lantern', [T.SOUL_LANTERN]: 'soul_lantern',
    [T.CAMPFIRE_LOG]: 'campfire_log', [T.CAMPFIRE_LOG_LIT]: 'campfire_log_lit', [T.CAMPFIRE_FIRE]: 'campfire_fire',
    [T.FLOWER_POT]: 'flower_pot', [T.ITEM_FRAME]: 'item_frame', [T.GLOW_ITEM_FRAME]: 'glow_item_frame',
    [T.LIGHTNING_ROD]: 'lightning_rod', [T.CANDLE]: 'candle', [T.CANDLE_LIT]: 'candle_lit',
    [T.COMPOSTER_COMPOST]: 'composter_compost', [T.COMPOSTER_READY]: 'composter_ready',
  };
}

/** The placeholder for a tile whose file is missing: one flat grey, nothing drawn on it. */
const placeholder: Painter = (ctx) => {
  ctx.fillStyle = 'rgb(128, 128, 128)';
  ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
};

export function utilityPainters(): Record<number, Painter> {
  const out: Record<number, Painter> = {};
  for (const tile of Object.keys(utilityTileFiles())) out[Number(tile)] = placeholder;
  return out;
}
